/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Shift = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        shift: {
    type: 'string',
    isRequired: true,
},
        startTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        endTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        createdAt: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        archivedAt: {
    type: 'string',
    isNullable: true,
    format: 'date-time',
},
    },
};